import React, { useContext, useEffect, useRef, useState } from 'react'
import { MyContext } from '../../Context/MyProvider'
import secureLocalStorage from 'react-secure-storage';
import axios from 'axios';
import { enqueueSnackbar } from 'notistack';
import { AnimatePresence, motion } from 'framer-motion';
import Payment from '../../Payment Getway/Payment';
import PageLoad from './PageLoad';
import { useNavigate, useLocation, Link } from 'react-router-dom';

const apiPreviewData = {
    horoscope: {
        title: "Daily Horoscope",
        method: "POST",
        endpoint: "/api/horoscope/daily",
        request: `// JavaScript (Fetch)
const response = await fetch("https://api.astrosphere.com/v1/horoscope/daily", {
  method: "POST",
  headers: {
    "Content-Type": "application/json",
    "x-api-key": "your_api_key"
  },
  body: JSON.stringify({
    sign: "leo",
    date: "2026-06-10"
  })
});
const data = await response.json();
console.log(data);`,
        response: `{
  "status": "success",
  "data": {
    "sign": "Leo",
    "date": "2026-06-10",
    "horoscope": "Today is a day of vibrant energy and leadership. Your Sun shines brightly on your career, opening new doors. Trust your courage.",
    "lucky_number": 7,
    "lucky_time": "11:30 AM",
    "compatibility": "Aries"
  }
}`
    },
    kundli: {
        title: "Kundli Chart",
        method: "POST",
        endpoint: "/api/kundli/birth-chart",
        request: `// JavaScript (Fetch)
const response = await fetch("https://api.astrosphere.com/v1/kundli/birth-chart", {
  method: "POST",
  headers: {
    "Content-Type": "application/json",
    "x-api-key": "your_api_key"
  },
  body: JSON.stringify({
    name: "Aarav Sharma",
    birth_date: "1995-08-15T10:30:00Z",
    latitude: 28.6139,
    longitude: 77.2090
  })
});
const data = await response.json();
console.log(data);`,
        response: `{
  "status": "success",
  "data": {
    "ascendant": "Virgo",
    "moon_sign": "Pisces",
    "sun_sign": "Leo",
    "planetary_positions": [
      { "planet": "Sun", "house": 11, "degree": 28.15 },
      { "planet": "Moon", "house": 7, "degree": 14.22 }
    ],
    "dasha_period": "Jupiter-Mercury"
  }
}`
    },
    tarot: {
        title: "Tarot Reading",
        method: "POST",
        endpoint: "/api/tarot/draw",
        request: `// JavaScript (Fetch)
const response = await fetch("https://api.astrosphere.com/v1/tarot/draw", {
  method: "POST",
  headers: {
    "Content-Type": "application/json",
    "x-api-key": "your_api_key"
  },
  body: JSON.stringify({
    cards_count: 1,
    question: "Should I start a new venture?"
  })
});
const data = await response.json();
console.log(data);`,
        response: `{
  "status": "success",
  "data": {
    "card": "The Magician",
    "orientation": "Upright",
    "meaning": "Creation, manifestation, resourcefulness, power. You have the tools necessary to succeed in your venture.",
    "advice": "Direct your willpower and focus towards your goals."
  }
}`
    }
};

const Home = () => {

    const { BaseUrl, catPackageList, setCatPackageList, aiPackageList, setWebLogo, setAiPackageList, planType, setPlanType, catActivePackage, isLoginAuth, paymentStatus, aiActivePackage, showModel, setShowModel, setPaymentStatus, selectPack, setSelectPack, setProfileShow, GetPackageRef, handleGetActivePackage } = useContext(MyContext);

    const [loading, setLoading] = useState(true);
    const [openFaqIndex, setOpenFaqIndex] = useState("");
    const [offlineSettings, setOfflineSettings] = useState({ paymenttoggle: 0, offlinepay_url: "" });
    const [typedResponse, setTypedResponse] = useState("");
    const [activeEndpoint, setActiveEndpoint] = useState("horoscope");

    useEffect(() => {
        setTypedResponse("");
        const fullText = apiPreviewData[activeEndpoint].response;
        let index = 0;
        const interval = setInterval(() => {
            setTypedResponse((prev) => prev + fullText.charAt(index));
            index++;
            if (index >= fullText.length) {
                clearInterval(interval);
            }
        }, 15);
        return () => clearInterval(interval);
    }, [activeEndpoint]);

    const PackageRef = useRef(false);
    const effectRan = useRef(false);
    const navigate = useNavigate();
    const location = useLocation();

    const currency = secureLocalStorage.getItem("currency");

    const renderPricingCard = (item, index, type) => {
        const isActive = type === "Category" 
            ? catActivePackage?.PackageID == item.id 
            : aiActivePackage?.AiPlanID == item.id;
            
        const isStandard = item.title === "Standard";
        
        return (
            <motion.div
                key={index}
                variants={{
                    hidden: { opacity: 0, y: 30 },
                    visible: {
                        opacity: 1,
                        y: 0,
                        transition: { duration: 0.6, delay: index * 0.15 },
                    },
                }}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                className="flex"
            >
                <div 
                    className={`w-full p-8 sm:p-10 rounded-2xl flex flex-col justify-between transition-all duration-300 relative border border-gray-100 hover:shadow-2xl hover:-translate-y-2 ${
                        isStandard 
                            ? "bg-black text-[#f6f1ea] border-black" 
                            : "bg-[#F8F9FA] text-[#2D2D2D]"
                    } ${
                        isActive 
                            ? (isStandard ? "active-plan-border-dark" : "active-plan-border-gray") 
                            : ""
                    }`}
                >
                    {isActive ? (
                        <div className="absolute -top-[15px] left-1/2 -translate-x-1/2">
                            <div className="active-badge">
                                <span>Active</span>
                                <button 
                                    onClick={() => { setShowModel("Package"); setPlanType(type); }} 
                                    className="flex items-center ml-1"
                                >
                                    <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" className="text-white text-[16px] hover:scale-110 duration-200" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M11 15h2v2h-2v-2zm0-8h2v6h-2V7zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"></path></svg>
                                </button>
                            </div>
                        </div>
                    ) : isStandard ? (
                        <div className="absolute top-0 left-1/2 -translate-x-1/2 bg-[#4f46e5] px-[12px] py-[4px] rounded-b-[10px] shadow-sm">
                            <span className="uppercase text-[11px] font-extrabold text-white tracking-widest">best value</span>
                        </div>
                    ) : null}

                    <div>
                        <div className="flex justify-between items-start mb-2">
                            <h2 className="text-[26px] font-black tracking-tight">{item.title}</h2>
                        </div>
                        <p className={`text-[15px] mb-6 font-medium ${isStandard ? "text-gray-400" : "text-gray-500"}`}>{item.members}</p>

                        <div className={`border-t mb-6 ${isStandard ? "border-white/10" : "border-gray-200"}`}></div>

                        <div className="flex items-baseline gap-1 mb-6">
                            <h1 className="text-[54px] font-black tracking-tight leading-none text-transparent bg-clip-text bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500">
                                {currency + item.valid_price}
                            </h1>
                            <span className={`text-[14px] font-medium ml-1 ${isStandard ? "text-gray-400" : "text-gray-500"}`}>
                                {item.price && <span className="line-through mr-1 opacity-60">{currency + item.price}</span>}
                                /month
                            </span>
                        </div>

                        <p className={`text-[15px] leading-relaxed mb-8 ${isStandard ? "text-gray-300" : "text-gray-600"}`}>
                            {item.description}
                        </p>
                    </div>

                    <div>
                        <button 
                            disabled={isActive} 
                            onClick={() => handleSelectPlan(item, type)} 
                            className={`w-full py-3.5 rounded-full font-bold text-[15px] transition-all duration-300 cursor-pointer ${
                                isActive 
                                    ? "bg-gray-100 text-gray-400 cursor-not-allowed border border-gray-200" 
                                    : isStandard
                                        ? "bg-[#4f46e5] text-white hover:bg-[#f6f1ea] hover:text-black hover:border-black border border-transparent"
                                        : "bg-black text-white hover:bg-[#4f46e5] hover:text-white border border-transparent"
                            }`}
                        >
                            {isActive ? "Currently Active" : `Upgrade to ${item.title}`}
                        </button>

                        <p className="uppercase text-[12px] tracking-wider font-extrabold mt-8 mb-4">What's included</p>

                        <div className="flex flex-col gap-3">
                            {item.future?.map((feature, fIdx) => (
                                <div key={fIdx} className="flex items-center gap-3">
                                    <svg className={`w-5 h-5 flex-shrink-0 ${isStandard ? "text-indigo-400" : "text-[#4f46e5]"}`} fill="currentColor" viewBox="0 0 20 20">
                                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                                    </svg>
                                    <p className={`text-[14px] ${isStandard ? "text-gray-300" : "text-gray-600"}`}>{feature}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </motion.div>
        );
    };

    // Handle hash-based scrolling when navigating from other pages (e.g., /api-docs -> /#module-price)
    useEffect(() => {
        if (location.hash) {
            const id = location.hash.replace('#', '');
            setTimeout(() => {
                document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
            }, 300);
        }
    }, [location.hash]);

    const defaultTestimonials = [
        {
            text: "AstroSphere's Kundli API saved us months of development. The data accuracy is incredible.",
            name: "Priya Sharma",
            role: "CTO at JyotishApp",
            img: "https://randomuser.me/api/portraits/women/32.jpg",
        },
        {
            text: "We integrated the horoscope endpoint in under an hour. Our users love the daily predictions.",
            name: "Rajesh Kumar",
            role: "Founder of StarSign Daily",
            img: "https://randomuser.me/api/portraits/men/45.jpg",
        },
        {
            text: "The AI astrology chat feature is a game-changer. It feels like talking to a real astrologer.",
            name: "Ananya Patel",
            role: "Product Lead at MysticAI",
            img: "https://randomuser.me/api/portraits/women/64.jpg",
        },
        {
            text: "Best astrology API we've tried. Clean docs, fast responses, great support.",
            name: "David Chen",
            role: "Senior Dev at ZodiacLabs",
            img: "https://randomuser.me/api/portraits/men/71.jpg",
        },
        {
            text: "The tarot and numerology endpoints opened up entirely new features for our app.",
            name: "Sarah Mitchell",
            role: "CEO of FortuneTell",
            img: "https://randomuser.me/api/portraits/women/81.jpg",
        },
        {
            text: "99.9% uptime and lightning-fast responses. Exactly what we needed for our production app.",
            name: "Marcus Johnson",
            role: "Backend Engineer at CosmicData",
            img: "https://randomuser.me/api/portraits/men/90.jpg",
        },
    ];

    const defaultFaqs = [
        { title: "What is AstroSphere API?", ans: "AstroSphere is a comprehensive REST API platform offering Kundli charts, horoscope predictions, tarot readings, numerology calculations, love compatibility, and AI-powered astrology consultations — all accessible via simple HTTP endpoints." },
        { title: "How do I get started?", ans: "Sign up, choose a plan, and you'll receive an API key instantly. Check our API Documentation for integration guides with code samples in cURL, JavaScript, and Python." },
        { title: "What authentication is required?", ans: "All endpoints require an `x-api-key` header with your subscription's purchase code. The login endpoint returns your credentials for managing your account programmatically." },
        { title: "Can I try before I buy?", ans: "Yes! Our starter plans include free tokens so you can test every endpoint before committing to a larger plan." },
        { title: "What happens when I run out of tokens?", ans: "Your API calls will return a rate-limit error. You can upgrade your plan anytime from the Account Dashboard without losing your existing data." },
    ];

    const [testimonials, setTestimonials] = useState(defaultTestimonials);
    const [FaqList, setFaqList] = useState(defaultFaqs);

    useEffect(() => {
        handleGetCategoryPackage();

        // Fetch FAQs from database
        axios.get(`${BaseUrl}/faqs`)
            .then(res => {
                if (res.data && res.data.status === 'success' && res.data.data && res.data.data.length > 0) {
                    setFaqList(res.data.data.map(item => ({ title: item.question, ans: item.answer })));
                }
            })
            .catch(err => console.error("Error fetching FAQs:", err));

        // Fetch Testimonials from database
        axios.get(`${BaseUrl}/reviews`)
            .then(res => {
                if (res.data && res.data.status === 'success' && res.data.data && res.data.data.length > 0) {
                    setTestimonials(res.data.data.map(item => ({ text: item.review, name: item.name, role: item.role, img: item.image_url })));
                }
            })
            .catch(err => console.error("Error fetching testimonials:", err));
    }, []);

    useEffect(() => {
        if (!paymentStatus || effectRan.current) return;
        effectRan.current = true;
        if (paymentStatus === "PaymentDone") {
            const Type = secureLocalStorage.getItem("Plantype");
            if (Type === "Category") {
                handlePurchaseCategoryPackage();
            } else {
                hadnlePurchaseAiPackage();
            }
        } else {
            setShowModel("PaymentFaild");
        }
        setPaymentStatus("");
        setSelectPack("");
    }, [paymentStatus]);

    const handleGetCategoryPackage = () => {
        if (PackageRef.current) return;
        PackageRef.current = true;

        axios.get(`${BaseUrl}/coustomer/services/list`)
            .then((res) => {
                setWebLogo(res.data.logo);
                setCatPackageList(res.data.Packages);
                setOfflineSettings({
                    paymenttoggle: res.data.paymenttoggle,
                    offlinepay_url: res.data.offlinepay_url
                });
                setLoading(false);
                secureLocalStorage.setItem("currency", res.data.currency);
            })
            .catch((error) => {
                console.error(error);
                setLoading(false);
            });

        axios.get(`${BaseUrl}/coustomer/services/Ai_ChatPlan_list`)
            .then((res) => {
                setAiPackageList(res.data.Packages_AI);
            })
            .catch((error) => {
                console.error(error);
            });
    }

    const handlePurchaseCategoryPackage = () => {

        const GetPackage = secureLocalStorage.getItem("package");
        const Localdata = secureLocalStorage.getItem("Localdata");
        const transection_id = sessionStorage.getItem("transactionid");

        if (GetPackage) {
            const JsconData = JSON.parse(Localdata);
            const { id, token, type } = JSON.parse(GetPackage);
            axios.post(`${BaseUrl}/coustomer/services/purchas_data`, { package_id: id, user_id: JsconData.id, tokens: token, transection_id, type })
                .then((res) => {
                    const ToastType = res.data.ResponseCode === 200 ? "success" : "error";
                    enqueueSnackbar(res.data.message, { variant: ToastType });
                    secureLocalStorage.removeItem("package");
                    sessionStorage.removeItem("transactionid");
                    setShowModel("");
                    setProfileShow("");
                    GetPackageRef.current = false;
                    effectRan.current = false;
                    handleGetActivePackage();
                })
                .catch((error) => {
                    console.error(error);
                });
        }
    }

    const hadnlePurchaseAiPackage = () => {
        const GetPackage = secureLocalStorage.getItem("package");
        const Localdata = secureLocalStorage.getItem("Localdata");
        const transection_id = sessionStorage.getItem("transactionid");

        if (GetPackage) {
            const JsconData = JSON.parse(Localdata);
            const { id, token, type } = JSON.parse(GetPackage);
            axios.post(`${BaseUrl}/coustomer/services/purchas_data_ai`, { package_id: id, user_id: JsconData.id, tokens: token, transection_id, type })
                .then((res) => {
                    const ToastType = res.data.ResponseCode === 200 ? "success" : "error";
                    enqueueSnackbar(res.data.message, { variant: ToastType });
                    secureLocalStorage.removeItem("package");
                    sessionStorage.removeItem("transactionid");
                    setShowModel("");
                    setProfileShow("");
                    GetPackageRef.current = false;
                    effectRan.current = false;
                    handleGetActivePackage();
                })
                .catch((error) => {
                    console.error(error);
                });
        }
    }

    const handleSelectPlan = (data, type) => {
        if (isLoginAuth) {
            navigate("/auth/login");
            return;
        }
        if (data && data.valid_price === 0) {
            const Localdata = secureLocalStorage.getItem("Localdata");
            if (!Localdata) {
                enqueueSnackbar('User session not found, please login again', { variant: 'error' });
                return;
            }
            const JsconData = JSON.parse(Localdata);
            const generatedTxId = "FREE-" + Date.now() + Math.random().toString(36).substring(2, 8).toUpperCase();
            
            const url = type === "Category" 
                ? `${BaseUrl}/coustomer/services/purchas_data` 
                : `${BaseUrl}/coustomer/services/purchas_data_ai`;
                
            axios.post(url, { 
                package_id: data.id, 
                user_id: JsconData.id, 
                tokens: data.token, 
                transection_id: generatedTxId, 
                type: "Manual" 
            })
            .then((res) => {
                const ToastType = res.data.ResponseCode === 200 ? "success" : "error";
                enqueueSnackbar(res.data.message, { variant: ToastType });
                handleGetActivePackage();
            })
            .catch((error) => {
                console.error(error);
                enqueueSnackbar('Failed to purchase free package', { variant: 'error' });
            });
            return;
        }
        if (offlineSettings && offlineSettings.paymenttoggle == 1) {
            if (offlineSettings.offlinepay_url) {
                window.location.href = offlineSettings.offlinepay_url;
            } else {
                enqueueSnackbar('Offline payment URL not configured', { variant: 'error' });
            }
            return;
        }
        setShowModel("Payment");
        setSelectPack(data);
        setPlanType(type);
    }

    const stars = React.useMemo(() => {
        return [...Array(8)].map((_, i) => ({
            id: i,
            top: `${15 + Math.random() * 60}%`,
            left: `${10 + Math.random() * 80}%`,
            duration: 3 + Math.random() * 4,
            delay: Math.random() * 2,
        }));
    }, []);

    return (
        <div className='home_page'>

            <div className="image_box">
                {/* Decorative floating radial gradients */}
                <div className="w-[400px] h-[400px] rounded-full bg-purple-600/10 blur-[100px] absolute top-[-10%] left-[5%] pointer-events-none" />
                <div className="w-[500px] h-[500px] rounded-full bg-indigo-600/10 blur-[120px] absolute bottom-[-10%] right-[5%] pointer-events-none" />

                {/* Rotating zodiac rings */}
                <div className="zodiac-ring w-[600px] h-[600px] opacity-70" style={{ top: '10%', left: '5%' }}></div>
                <div className="zodiac-ring w-[400px] h-[400px] opacity-40" style={{ bottom: '15%', right: '10%', animationDirection: 'reverse', animationDuration: '40s' }}></div>

                {/* Sparkling Stars */}
                {stars.map((star) => (
                    <motion.div
                        key={star.id}
                        className="absolute w-1.5 h-1.5 bg-white rounded-full opacity-35 pointer-events-none"
                        style={{
                            top: star.top,
                            left: star.left,
                        }}
                        animate={{
                            scale: [0.6, 1.3, 0.6],
                            opacity: [0.25, 0.9, 0.25],
                        }}
                        transition={{
                            duration: star.duration,
                            repeat: Infinity,
                            ease: "easeInOut",
                            delay: star.delay,
                        }}
                    />
                ))}

                <div className="width_container z-10 relative px-4">
                    <div className="text-center mt-[30px]">
                        <motion.h1
                            variants={{
                                hidden: { opacity: 0, y: 35 },
                                visible: {
                                    opacity: 1,
                                    y: 0,
                                    transition: { duration: 0.9, ease: "easeOut", delay: 0.3 },
                                },
                            }}
                            initial="hidden"
                            whileInView="visible"
                            viewport={{ once: true }}
                            className="text-white font-extrabold text-[46px] sm:text-[60px] md:text-[70px] leading-[1.1] tracking-tight"
                        >
                            Unlock the Power of the Stars <br />
                            <span className="text-transparent bg-clip-text bg-gradient-to-r from-indigo-400 via-purple-400 to-pink-400">
                                with the Most Complete Astrology API
                            </span>
                        </motion.h1>

                        <motion.p
                            variants={{
                                hidden: { opacity: 0, y: 30 },
                                visible: {
                                    opacity: 1,
                                    y: 0,
                                    transition: { duration: 0.9, ease: "easeOut", delay: 0.5 },
                                },
                            }}
                            initial="hidden"
                            whileInView="visible"
                            viewport={{ once: true }}
                            className="mt-6 text-[16px] sm:text-[19px] max-w-3xl mx-auto text-gray-300 leading-relaxed"
                        >
                            Kundli charts, horoscope predictions, tarot readings, numerology & AI-powered astrology — all through a single REST API. Build mystical experiences your users will love.
                        </motion.p>
                    </div>

                    <motion.div 
                        variants={{
                            hidden: { opacity: 0, y: 20 },
                            visible: {
                                opacity: 1,
                                y: 0,
                                transition: { duration: 0.8, ease: "easeOut", delay: 0.7 },
                            },
                        }}
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true }}
                        className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-8"
                    >
                        <button 
                            onClick={() => document.getElementById("module-price")?.scrollIntoView({ behavior: "smooth" })}
                            className="px-8 py-3.5 bg-gradient-to-r from-indigo-600 to-purple-600 text-white font-bold rounded-full shadow-lg hover:shadow-indigo-500/20 hover:scale-[1.03] transition-all duration-300 cursor-pointer w-full sm:w-auto"
                        >
                            Explore the API
                        </button>
                        <button 
                            onClick={() => navigate("/api-docs")}
                            className="px-8 py-3.5 bg-white/10 hover:bg-white/15 text-white font-bold rounded-full border border-white/20 backdrop-blur-sm transition-all duration-300 cursor-pointer w-full sm:w-auto"
                        >
                            View Documentation
                        </button>
                    </motion.div>

                    {/* Stats Strip */}
                    <motion.div
                        variants={{
                            hidden: { opacity: 0, y: 30 },
                            visible: {
                                opacity: 1,
                                y: 0,
                                transition: { duration: 0.8, ease: "easeOut", delay: 0.9 },
                            },
                        }}
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true }}
                        className="mt-16 flex flex-col sm:flex-row justify-center items-center gap-6 sm:gap-12 px-8 py-5 rounded-2xl bg-white/5 border border-white/10 backdrop-blur-md max-w-2xl mx-auto"
                    >
                        <div className="text-center px-4">
                            <p className="text-[28px] font-black text-transparent bg-clip-text bg-gradient-to-r from-indigo-400 to-purple-400">9</p>
                            <p className="text-[11px] text-gray-400 uppercase tracking-widest font-semibold mt-1">API Endpoints</p>
                        </div>
                        <div className="w-[1px] h-8 bg-white/10 hidden sm:block"></div>
                        <div className="text-center px-4">
                            <p className="text-[28px] font-black text-transparent bg-clip-text bg-gradient-to-r from-indigo-400 to-purple-400">10k+</p>
                            <p className="text-[11px] text-gray-400 uppercase tracking-widest font-semibold mt-1">Daily API Calls</p>
                        </div>
                        <div className="w-[1px] h-8 bg-white/10 hidden sm:block"></div>
                        <div className="text-center px-4">
                            <p className="text-[28px] font-black text-transparent bg-clip-text bg-gradient-to-r from-indigo-400 to-purple-400">99.9%</p>
                            <p className="text-[11px] text-gray-400 uppercase tracking-widest font-semibold mt-1">Service Uptime</p>
                        </div>
                    </motion.div>
                </div>
            </div>

            {/* ── Creative Cosmic Wave Divider ── */}
            <div className="wave-divider">
                <svg viewBox="0 0 1440 120" preserveAspectRatio="none" width="100%" height="120"
                    xmlns="http://www.w3.org/2000/svg">
                    <defs>
                        {/* ── Back arch: dark purple peaks at center ── */}
                        <linearGradient id="waveDeep" x1="0" y1="0" x2="1" y2="0">
                            <stop offset="0%"   stopColor="#080614" />
                            <stop offset="20%"  stopColor="#100830" />
                            <stop offset="50%"  stopColor="#1a0d45" />
                            <stop offset="80%"  stopColor="#100830" />
                            <stop offset="100%" stopColor="#080614" />
                        </linearGradient>

                        {/* ── Front arch: near-black ── */}
                        <linearGradient id="waveFront" x1="0" y1="0" x2="1" y2="0">
                            <stop offset="0%"   stopColor="#080614" />
                            <stop offset="50%"  stopColor="#0c0620" />
                            <stop offset="100%" stopColor="#080614" />
                        </linearGradient>

                        {/* ── Ridge: perfectly symmetric indigo→pink→indigo ── */}
                        <linearGradient id="ridgeGlow" x1="0" y1="0" x2="1" y2="0">
                            <stop offset="0%"   stopColor="#4f46e5" stopOpacity="0"   />
                            <stop offset="20%"  stopColor="#6d28d9" stopOpacity="0.6" />
                            <stop offset="50%"  stopColor="#ec4899" stopOpacity="1"   />
                            <stop offset="80%"  stopColor="#6d28d9" stopOpacity="0.6" />
                            <stop offset="100%" stopColor="#4f46e5" stopOpacity="0"   />
                        </linearGradient>

                        {/* ── Halo: wider diffuse aurora ── */}
                        <linearGradient id="haloGlow" x1="0" y1="0" x2="1" y2="0">
                            <stop offset="0%"   stopColor="#818cf8" stopOpacity="0"    />
                            <stop offset="25%"  stopColor="#a78bfa" stopOpacity="0.28" />
                            <stop offset="50%"  stopColor="#f472b6" stopOpacity="0.4"  />
                            <stop offset="75%"  stopColor="#a78bfa" stopOpacity="0.28" />
                            <stop offset="100%" stopColor="#818cf8" stopOpacity="0"    />
                        </linearGradient>

                        {/* ── Blur for halo diffusion ── */}
                        <filter id="haloBlur" x="-30%" y="-300%" width="160%" height="700%">
                            <feGaussianBlur stdDeviation="5" />
                        </filter>
                    </defs>

                    {/* ── Layer 1 – deep back arch ── */}
                    <path
                        d="M0,0 L0,88 C200,62 480,18 720,8 C960,18 1240,62 1440,88 L1440,0 Z"
                        fill="url(#waveDeep)"
                    />

                    {/* ── Layer 2 – front crisp arch ── */}
                    <path
                        d="M0,0 L0,72 C240,48 520,4 720,0 C920,4 1200,48 1440,72 L1440,0 Z"
                        fill="url(#waveFront)"
                    />

                    {/* ── Halo glow (blurred, animated) ── */}
                    <path
                        className="wave-halo"
                        d="M0,72 C240,48 520,4 720,0 C920,4 1200,48 1440,72"
                        fill="none"
                        stroke="url(#haloGlow)"
                        strokeWidth="36"
                        filter="url(#haloBlur)"
                    />

                    {/* ── Crisp ridge line (animated) ── */}
                    <path
                        className="wave-glow-ridge"
                        d="M0,72 C240,48 520,4 720,0 C920,4 1200,48 1440,72"
                        fill="none"
                        stroke="url(#ridgeGlow)"
                        strokeWidth="2.5"
                    />

                    {/* ── Subtle offset echo line for depth ── */}
                    <path
                        d="M0,76 C240,52 520,8 720,4 C920,8 1200,52 1440,76"
                        fill="none"
                        stroke="url(#haloGlow)"
                        strokeWidth="1"
                        opacity="0.4"
                    />
                </svg>
            </div>

            {/* Features Grid Section */}
            <div className="py-20 bg-white relative">
                <div className="width_container px-4">
                    <div className="text-center max-w-3xl mx-auto mb-16">
                        <motion.h2 
                            variants={{
                                hidden: { opacity: 0, y: 20 },
                                visible: { opacity: 1, y: 0, transition: { duration: 0.8 } }
                            }}
                            initial="hidden"
                            whileInView="visible"
                            viewport={{ once: true }}
                            className="font-bold text-[36px] sm:text-[45px] text-black leading-tight"
                        >
                            Everything You Need to Build <span className="text-[#4f46e5]">Astrology Apps</span>
                        </motion.h2>
                        <motion.p
                            variants={{
                                hidden: { opacity: 0, y: 20 },
                                visible: { opacity: 1, y: 0, transition: { duration: 0.8, delay: 0.2 } }
                            }}
                            initial="hidden"
                            whileInView="visible"
                            viewport={{ once: true }}
                            className="text-[17px] sm:text-[19px] text-gray-600 mt-4"
                        >
                            From birth charts to AI consultations — 9 powerful endpoints at your fingertips
                        </motion.p>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                        {[
                            { icon: "🔮", title: "Kundli / Birth Chart", desc: "Generate detailed birth charts with planetary positions, houses & Dasha periods.", color: "bg-purple-50 text-purple-600" },
                            { icon: "⭐", title: "Daily Horoscope", desc: "Daily, weekly, monthly & yearly predictions for all 12 zodiac signs.", color: "bg-amber-50 text-amber-600" },
                            { icon: "🔢", title: "Numerology", desc: "Life Path, Destiny & Soul Urge numbers from name and birth date.", color: "bg-blue-50 text-blue-600" },
                            { icon: "🃏", title: "Tarot Readings", desc: "Draw 1-3 cards for love, career, finance & general readings.", color: "bg-rose-50 text-rose-600" },
                            { icon: "🥠", title: "Fortune Cookie", desc: "Fun fortune messages with lucky numbers and times.", color: "bg-orange-50 text-orange-600" },
                            { icon: "💕", title: "Love Compatibility", desc: "Romantic compatibility scores between any two zodiac signs.", color: "bg-pink-50 text-pink-600" },
                            { icon: "🎁", title: "Zodiac Gift Guide", desc: "Personalized gift ideas based on zodiac personality traits.", color: "bg-emerald-50 text-emerald-600" },
                            { icon: "🤖", title: "AI Astrology Chat", desc: "Advanced AI engine for personalized astrology Q&A.", color: "bg-indigo-50 text-indigo-600" },
                            { icon: "🔐", title: "Authentication", desc: "Secure API key auth with subscription management.", color: "bg-gray-100 text-gray-700" }
                        ].map((feat, idx) => (
                            <motion.div
                                key={idx}
                                variants={{
                                    hidden: { opacity: 0, y: 30 },
                                    visible: {
                                        opacity: 1,
                                        y: 0,
                                        transition: { duration: 0.6, delay: (idx % 3) * 0.15 }
                                    }
                                }}
                                initial="hidden"
                                whileInView="visible"
                                viewport={{ once: true, margin: "-100px" }}
                                className="bg-white p-8 rounded-2xl border border-gray-100 hover:border-gray-200 hover:shadow-xl hover:-translate-y-1.5 transition-all duration-300 flex flex-col items-start"
                            >
                                <div className={`w-12 h-12 rounded-xl flex items-center justify-center text-[22px] mb-6 ${feat.color}`}>
                                    {feat.icon}
                                </div>
                                <h3 className="text-[20px] font-bold text-black mb-3">{feat.title}</h3>
                                <p className="text-gray-600 text-[15px] leading-relaxed">{feat.desc}</p>
                            </motion.div>
                        ))}
                    </div>
                </div>
            </div>

            {/* How It Works Section */}
            <div className="py-20 bg-gray-50/50 border-y border-gray-100 relative overflow-hidden">
                {/* Background stars */}
                <div className="absolute top-10 left-10 w-2 h-2 bg-indigo-200 rounded-full animate-pulse" />
                <div className="absolute bottom-10 right-10 w-3 h-3 bg-purple-200 rounded-full animate-pulse" />

                <div className="width_container px-4 relative">
                    <div className="text-center max-w-3xl mx-auto mb-16">
                        <motion.h2
                            variants={{
                                hidden: { opacity: 0, y: 20 },
                                visible: { opacity: 1, y: 0, transition: { duration: 0.8 } }
                            }}
                            initial="hidden"
                            whileInView="visible"
                            viewport={{ once: true }}
                            className="font-bold text-[36px] sm:text-[45px] text-black"
                        >
                            Up and Running in <span className="text-[#4f46e5]">Minutes</span>
                        </motion.h2>
                        <p className="text-[17px] text-gray-500 mt-3">Simple integration process for developers of all experience levels</p>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-3 gap-12 relative">
                        {/* Connecting Line (Desktop) */}
                        <div className="absolute top-8 left-[15%] right-[15%] h-[2px] border-t-2 border-dashed border-indigo-200/60 hidden md:block z-0" />

                        {[
                            { num: "01", title: "Choose Your Plan", desc: "Pick a subscription that fits your needs — from starter to enterprise." },
                            { num: "02", title: "Get Your API Key", desc: "Instantly receive your unique API key from the account dashboard." },
                            { num: "03", title: "Start Building", desc: "Make your first API call and integrate astrology into your app." }
                        ].map((step, idx) => (
                            <motion.div
                                key={idx}
                                variants={{
                                    hidden: { opacity: 0, y: 30 },
                                    visible: {
                                        opacity: 1,
                                        y: 0,
                                        transition: { duration: 0.7, delay: idx * 0.2 }
                                    }
                                }}
                                initial="hidden"
                                whileInView="visible"
                                viewport={{ once: true }}
                                className="flex flex-col items-center text-center relative z-10"
                            >
                                <div className="w-16 h-16 rounded-2xl bg-white border border-gray-100 shadow-md flex items-center justify-center mb-6">
                                    <span className="text-[22px] font-black text-transparent bg-clip-text bg-gradient-to-r from-indigo-500 to-purple-600">
                                        {step.num}
                                    </span>
                                </div>
                                <h3 className="text-[20px] font-bold text-black mb-3">{step.title}</h3>
                                <p className="text-gray-600 text-[15px] leading-relaxed max-w-xs">{step.desc}</p>
                            </motion.div>
                        ))}
                    </div>
                </div>
            </div>

            {/* API Live Preview Section */}
            <div className="py-20 bg-[#080614] text-white relative overflow-hidden">
                {/* Background glowing gradients */}
                <div className="w-[300px] h-[300px] rounded-full bg-indigo-600/10 blur-[100px] absolute top-[-5%] right-[5%] pointer-events-none" />
                
                <div className="width_container px-4 relative">
                    <div className="text-center max-w-3xl mx-auto mb-16">
                        <motion.h2
                            variants={{
                                hidden: { opacity: 0, y: 20 },
                                visible: { opacity: 1, y: 0, transition: { duration: 0.8 } }
                            }}
                            initial="hidden"
                            whileInView="visible"
                            viewport={{ once: true }}
                            className="font-bold text-[36px] sm:text-[45px] text-white"
                        >
                            See It in <span className="text-transparent bg-clip-text bg-gradient-to-r from-indigo-400 to-purple-400">Action</span>
                        </motion.h2>
                        <p className="text-[17px] text-gray-400 mt-3">Try a real API response — no signup required</p>
                    </div>

                    {/* Tabs */}
                    <div className="flex flex-wrap justify-center gap-3 mb-8">
                        {Object.keys(apiPreviewData).map((key) => (
                            <button
                                key={key}
                                onClick={() => setActiveEndpoint(key)}
                                className={`px-5 py-2 rounded-full font-bold text-[14px] transition-all duration-300 cursor-pointer ${
                                    activeEndpoint === key
                                        ? "bg-indigo-600 text-white shadow-lg shadow-indigo-600/20"
                                        : "bg-white/5 text-gray-400 hover:bg-white/10 hover:text-white"
                                }`}
                            >
                                {apiPreviewData[key].title}
                            </button>
                        ))}
                    </div>

                    {/* Editor & Console Grid */}
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-stretch">
                        {/* Request Box */}
                        <div className="bg-[#0b0919] border border-white/5 rounded-2xl overflow-hidden shadow-2xl flex flex-col">
                            <div className="px-6 py-4 bg-[#0d0a21] border-b border-white/5 flex justify-between items-center">
                                <div className="flex items-center gap-2">
                                    <span className="w-3 h-3 rounded-full bg-red-500" />
                                    <span className="w-3 h-3 rounded-full bg-yellow-500" />
                                    <span className="w-3 h-3 rounded-full bg-green-500" />
                                </div>
                                <span className="text-[12px] font-mono text-gray-400">Request.js</span>
                            </div>
                            <div className="p-6 font-mono text-[14px] leading-relaxed overflow-x-auto text-left text-gray-300 flex-1">
                                <pre className="whitespace-pre">
                                    {apiPreviewData[activeEndpoint].request}
                                </pre>
                            </div>
                        </div>

                        {/* Response Box */}
                        <div className="bg-[#0b0919] border border-white/5 rounded-2xl overflow-hidden shadow-2xl flex flex-col">
                            <div className="px-6 py-4 bg-[#0d0a21] border-b border-white/5 flex justify-between items-center">
                                <div className="flex items-center gap-3">
                                    <span className="text-[12px] font-mono text-gray-400">Response JSON</span>
                                    <span className="px-2 py-0.5 rounded text-[10px] bg-emerald-500/10 text-emerald-400 font-bold border border-emerald-500/20">200 OK</span>
                                </div>
                                <button 
                                    onClick={() => {
                                        navigator.clipboard.writeText(apiPreviewData[activeEndpoint].response);
                                        enqueueSnackbar("Copied to clipboard!", { variant: "success" });
                                    }}
                                    className="text-[12px] text-gray-400 hover:text-white flex items-center gap-1 cursor-pointer transition-colors"
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path></svg>
                                    Copy
                                </button>
                            </div>
                            <div className="p-6 font-mono text-[14px] leading-relaxed text-emerald-400 text-left overflow-x-auto flex-1 bg-[#090715]">
                                <pre className="whitespace-pre">{typedResponse}</pre>
                            </div>
                        </div>
                    </div>

                    <div className="text-center mt-12">
                        <Link 
                            to="/api-docs" 
                            className="inline-flex items-center gap-2 text-indigo-400 hover:text-indigo-300 font-bold transition-all hover:gap-3 cursor-pointer"
                        >
                            View Full Documentation
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M5 12H19M19 12L13 6M19 12L13 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                        </Link>
                    </div>
                </div>
            </div>

            {catPackageList.length >= 1 && <div id="module-price" className="width_container py-16">
                <div className="price_box">
                    <div className="text-center mb-12">
                        <h1 className="font-bold text-[40px] sm:text-[50px] text-black">Choose Your Module Plan</h1>
                        <p className="text-[18px] sm:text-[22px] text-gray-500 mt-2">Powerful astrology tools at every scale</p>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mt-8">
                        {catPackageList.map((item, index) => renderPricingCard(item, index, "Category"))}
                    </div>

                </div>
            </div>}

            {aiPackageList.length >= 1 && <div id="ai-price" className="width_container py-16 border-t border-gray-100">
                <div className="price_box">
                    <div className="text-center mb-12">
                        <h1 className="font-bold text-[40px] sm:text-[50px] text-black">Supercharge with AI</h1>
                        <p className="text-[18px] sm:text-[22px] text-gray-500 mt-2">Add intelligent astrology consultations to your app</p>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mt-8">
                        {aiPackageList.map((item, index) => renderPricingCard(item, index, "Ai"))}
                    </div>

                </div>
            </div>}

            {testimonials.length >= 1 && <div id="review" className="py-24 bg-gradient-to-b from-[#080614] to-[#04030a] relative overflow-hidden">
                {/* Background soft glowing orb */}
                <div className="w-[400px] h-[400px] rounded-full bg-purple-600/5 blur-[120px] absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none" />

                <div className="width_container px-4 relative">

                    <div className="text-center max-w-3xl mx-auto mb-16">
                        <motion.h2
                            variants={{
                                hidden: { opacity: 0, y: 20 },
                                visible: { opacity: 1, y: 0, transition: { duration: 0.8 } }
                            }}
                            initial="hidden"
                            whileInView="visible"
                            viewport={{ once: true }}
                            className="font-bold text-[36px] sm:text-[45px] text-white"
                        >
                            Loved by <span className="text-transparent bg-clip-text bg-gradient-to-r from-indigo-400 to-purple-400">Developers & Astrologers</span>
                        </motion.h2>
                        <p className="text-[17px] text-gray-400 mt-3">See how companies are building next-generation celestial apps with AstroSphere</p>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                        {testimonials.map((item, index) => (
                            <motion.div
                                key={index}
                                variants={{
                                    hidden: { opacity: 0, y: 30 },
                                    visible: {
                                        opacity: 1,
                                        y: 0,
                                        transition: { duration: 0.6, delay: (index % 3) * 0.15 },
                                    },
                                }}
                                initial="hidden"
                                whileInView="visible"
                                viewport={{ once: true }}
                                className="bg-white/5 border border-white/5 hover:border-indigo-500/20 rounded-2xl p-8 transition-all duration-300 relative overflow-hidden flex flex-col justify-between hover:shadow-2xl hover:shadow-indigo-500/5 hover:-translate-y-1"
                            >
                                <div className="absolute right-6 top-4 text-white/5 font-serif text-[100px] select-none pointer-events-none leading-none">”</div>
                                
                                <div>
                                    <div className="flex items-center gap-1 mb-5">
                                        {[...Array(5)].map((_, i) => (
                                            <svg key={i} className="w-5 h-5 text-amber-400 fill-current" viewBox="0 0 20 20">
                                                <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                                            </svg>
                                        ))}
                                    </div>

                                    <p className="text-gray-300 text-[15px] leading-relaxed mb-8 relative z-10 italic">
                                        "{item.text}"
                                    </p>
                                </div>

                                <div className="flex items-center gap-4 relative z-10">
                                    <img
                                        src={item.img}
                                        alt={item.name}
                                        className="w-12 h-12 rounded-full object-cover border-2 border-indigo-500/30"
                                    />
                                    <div>
                                        <h4 className="text-white font-bold text-[16px]">{item.name}</h4>
                                        <p className="text-gray-400 text-[13px]">{item.role}</p>
                                    </div>
                                </div>
                            </motion.div>
                        ))}
                    </div>

                </div>
            </div>}

            <div id="faq's" className="py-24 bg-white scroll-mt-[100px]">
                <div className="width_container px-4">

                    <h1 className="font-bold text-[36px] sm:text-[45px] text-center text-black">
                        Frequently Asked <br className="sm:hidden" />
                        <span className="text-[#4f46e5]">Questions</span>
                    </h1>

                    <motion.div
                        className="mt-12 max-w-4xl mx-auto"
                        variants={{
                            hidden: { opacity: 0, y: 30 },
                            visible: {
                                opacity: 1,
                                y: 0,
                                transition: { duration: 0.8, delay: 0.2 },
                            },
                        }}
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true }}
                    >
                        {FaqList.map((item, index) => {
                            const isOpen = index === openFaqIndex;
                            return (
                                <div
                                    key={index}
                                    className={`border-l-4 transition-all duration-300 ${
                                        isOpen 
                                            ? "border-[#4f46e5] bg-indigo-50/10 shadow-sm" 
                                            : "border-transparent bg-gray-50 hover:bg-gray-100/70"
                                    } rounded-r-2xl mt-4 overflow-hidden p-6 cursor-pointer`}
                                    onClick={() => setOpenFaqIndex(isOpen ? null : index)}
                                >
                                    <div className="flex items-center justify-between gap-4">
                                        <div className="flex items-center gap-4">
                                            <div className={`w-8 h-8 rounded-full flex items-center justify-center font-bold text-[14px] transition-colors duration-300 ${
                                                isOpen ? "bg-[#4f46e5] text-white" : "bg-gray-200 text-gray-700"
                                            }`}>
                                                {index + 1}
                                            </div>
                                            <h3 className="font-bold text-[17px] sm:text-[18px] text-black">
                                                {item.title}
                                            </h3>
                                        </div>
                                        <motion.button
                                            animate={{ rotate: isOpen ? 45 : 0 }}
                                            className={`p-1.5 rounded-full transition-colors duration-300 ${
                                                isOpen ? "bg-indigo-100 text-[#4f46e5]" : "bg-gray-200 text-gray-600"
                                            }`}
                                        >
                                            <svg
                                                width="12"
                                                height="12"
                                                viewBox="0 0 16 16"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M15 7H9V1C9 0.448 8.552 0 8 0C7.448 0 7 0.448 7 1V7H1C0.448 7 0 7.448 0 8C0 8.552 0.448 9 1 9H7V15C7 15.552 7.448 16 8 16C8.552 16 9 15.552 9 15V9H15C15.552 9 16 8.552 16 8C16 7.448 15.552 7 15 7Z"
                                                    fill="currentColor"
                                                />
                                            </svg>
                                        </motion.button>
                                    </div>

                                    <AnimatePresence initial={false}>
                                        {isOpen && (
                                            <motion.div
                                                key="content"
                                                initial="collapsed"
                                                animate="open"
                                                exit="collapsed"
                                                variants={{
                                                    open: { height: "auto", opacity: 1, marginTop: 16 },
                                                    collapsed: { height: 0, opacity: 0, marginTop: 0 },
                                                }}
                                                transition={{ duration: 0.3, ease: "easeInOut" }}
                                                className="text-gray-600 text-[15px] leading-relaxed pl-12 font-medium"
                                            >
                                                {item.ans}
                                            </motion.div>
                                        )}
                                    </AnimatePresence>
                                </div>
                            );
                        })}
                    </motion.div>

                </div>
            </div>

            <AnimatePresence initial={false}>
                {showModel === "Payment" && <div className="model items-center">
                    <motion.div
                        key="content"
                        initial="close"
                        animate="open"
                        exit="close"
                        variants={{
                            open: { opacity: 1, y: 0 },
                            close: { opacity: 0, y: 30 },
                        }}
                        transition={{ duration: 0.3 }}
                        onClick={(e) => e.stopPropagation()}
                        className="bg-white p-[20px] mx-[10px] rounded-[15px] relative w-[450px]"
                    >
                        <button onClick={() => setShowModel("")} className="absolute -top-[8px] -right-[8px] bg-black p-[10px] rounded-full group">
                            <svg width="12" height="12" className="transform transition-transform duration-300 ease-in-out group-hover:rotate-90" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M8.41425 7.00022L13.7073 1.70719C14.0983 1.31719 14.0983 0.68325 13.7073 0.29325C13.3163 -0.09775 12.6842 -0.09775 12.2933 0.29325L7.00025 5.58622L1.70725 0.29325C1.31625 -0.09775 0.68425 -0.09775 0.29325 0.29325C-0.09775 0.68325 -0.09775 1.31719 0.29325 1.70719L5.58625 7.00022L0.29325 12.2933C-0.09775 12.6833 -0.09775 13.3172 0.29325 13.7072C0.48825 13.9022 0.744251 14.0002 1.00025 14.0002C1.25625 14.0002 1.51225 13.9022 1.70725 13.7072L7.00025 8.41422L12.2933 13.7072C12.4882 13.9022 12.7443 14.0002 13.0003 14.0002C13.2563 14.0002 13.5123 13.9022 13.7073 13.7072C14.0983 13.3172 14.0983 12.6833 13.7073 12.2933L8.41425 7.00022Z" fill="white" />
                            </svg>
                        </button>

                        <Payment Amount={selectPack?.valid_price} data={selectPack} type={planType} />
                    </motion.div>
                </div>}
            </AnimatePresence>

            <AnimatePresence initial={false}>
                {showModel === "PaymentFaild" && <div className="model items-center">
                    <motion.div
                        key="content"
                        initial="close"
                        animate="open"
                        exit="close"
                        variants={{
                            open: { opacity: 1, y: 0 },
                            close: { opacity: 0, y: 30 },
                        }}
                        transition={{ duration: 0.3, delay: 0.3 }}
                        className="bg-white p-[20px] mx-[10px] rounded-[15px] relative w-[450px]"
                    >
                        <button onClick={() => setShowModel("")} className="absolute -top-[8px] -right-[8px] bg-black p-[10px] rounded-full group">
                            <svg width="12" height="12" className="transform transition-transform duration-300 ease-in-out group-hover:rotate-90" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M8.41425 7.00022L13.7073 1.70719C14.0983 1.31719 14.0983 0.68325 13.7073 0.29325C13.3163 -0.09775 12.6842 -0.09775 12.2933 0.29325L7.00025 5.58622L1.70725 0.29325C1.31625 -0.09775 0.68425 -0.09775 0.29325 0.29325C-0.09775 0.68325 -0.09775 1.31719 0.29325 1.70719L5.58625 7.00022L0.29325 12.2933C-0.09775 12.6833 -0.09775 13.3172 0.29325 13.7072C0.48825 13.9022 0.744251 14.0002 1.00025 14.0002C1.25625 14.0002 1.51225 13.9022 1.70725 13.7072L7.00025 8.41422L12.2933 13.7072C12.4882 13.9022 12.7443 14.0002 13.0003 14.0002C13.2563 14.0002 13.5123 13.9022 13.7073 13.7072C14.0983 13.3172 14.0983 12.6833 13.7073 12.2933L8.41425 7.00022Z" fill="white" />
                            </svg>
                        </button>

                        <div className="text-center py-4">

                            <div className="">
                                <svg style={{ boxShadow: "0 0 0 rgb( 0 0 0)" }} width="40" height="40" className='mx-auto text-red-600' viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M21.6069 17.1522L14.9999 4.79599C13.7199 2.40199 10.2809 2.40199 8.99993 4.79599L2.393 17.1522C1.219 19.3482 2.81304 22.0001 5.30804 22.0001H18.6918C21.1858 22.0001 22.7809 19.3472 21.6069 17.1522ZM11.2499 10.0001C11.2499 9.58609 11.5859 9.25009 11.9999 9.25009C12.4139 9.25009 12.7499 9.58609 12.7499 10.0001V14.0001C12.7499 14.4141 12.4139 14.7501 11.9999 14.7501C11.5859 14.7501 11.2499 14.4141 11.2499 14.0001V10.0001ZM12.02 18.0001C11.468 18.0001 11.0148 17.5521 11.0148 17.0001C11.0148 16.4481 11.4579 16.0001 12.0099 16.0001H12.02C12.573 16.0001 13.02 16.4481 13.02 17.0001C13.02 17.5521 12.572 18.0001 12.02 18.0001Z" fill="currentColor" />
                                </svg>
                            </div>

                            <h1 className='font-bold text-[25px] mt-2'>Payment Cancelled</h1>
                            <p className='font-bold text-[15px] text-gray-600'>Payment was cancelled</p>

                            <button onClick={() => setShowModel("")} className='bg-black text-white mt-6 px-[40px] py-[10px] rounded-[50px] font-bold text-[15px] hover:shadow-lg hover:scale-[1.02] hover:-translate-y-[1px] duration-300 transition-all'>Close</button>
                        </div>

                    </motion.div>
                </div>}
            </AnimatePresence>

            <AnimatePresence initial={false}>
                {showModel === "Package" && <div className="model items-center">
                    <motion.div
                        key="content"
                        initial="close"
                        animate="open"
                        exit="close"
                        variants={{
                            open: { opacity: 1, y: 0 },
                            close: { opacity: 0, y: 30 },
                        }}
                        transition={{ duration: 0.3 }}
                        onClick={(e) => e.stopPropagation()}
                        className="bg-white px-[20px] py-[10px] mx-[10px] rounded-[15px] relative w-[450px]"
                    >
                        <button onClick={() => setShowModel("")} className="absolute -top-[8px] -right-[8px] bg-black p-[10px] rounded-full group">
                            <svg width="12" height="12" className="transform transition-transform duration-300 ease-in-out group-hover:rotate-90" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M8.41425 7.00022L13.7073 1.70719C14.0983 1.31719 14.0983 0.68325 13.7073 0.29325C13.3163 -0.09775 12.6842 -0.09775 12.2933 0.29325L7.00025 5.58622L1.70725 0.29325C1.31625 -0.09775 0.68425 -0.09775 0.29325 0.29325C-0.09775 0.68325 -0.09775 1.31719 0.29325 1.70719L5.58625 7.00022L0.29325 12.2933C-0.09775 12.6833 -0.09775 13.3172 0.29325 13.7072C0.48825 13.9022 0.744251 14.0002 1.00025 14.0002C1.25625 14.0002 1.51225 13.9022 1.70725 13.7072L7.00025 8.41422L12.2933 13.7072C12.4882 13.9022 12.7443 14.0002 13.0003 14.0002C13.2563 14.0002 13.5123 13.9022 13.7073 13.7072C14.0983 13.3172 14.0983 12.6833 13.7073 12.2933L8.41425 7.00022Z" fill="white" />
                            </svg>
                        </button>

                        {(() => {
                            const activePkg = planType === "Ai" ? aiActivePackage : catActivePackage;
                            return <>
                                <div className="flex items-center justify-between py-[5px]">
                                    <span>Payment method</span>
                                    <span>{activePkg?.payment_type}</span>
                                </div>
                                <div className="flex items-center justify-between py-[5px] border-b-[2px]">
                                    <span>Transaction id</span>
                                    <span>{activePkg?.transection_id}</span>
                                </div>
                                <div className="flex items-center justify-between py-[5px]">
                                    <span>Date of Purchase</span>
                                    <span>{activePkg?.StartDate}</span>
                                </div>
                                <div className="flex items-center justify-between py-[5px] border-b-[2px]">
                                    <span>Date of Expiry</span>
                                    <span>{activePkg?.EndDate}</span>
                                </div>
                                <div className="flex items-center justify-between py-[5px]">
                                    <span>Membership Amount</span>
                                    <span>{currency + activePkg?.valid_price}</span>
                                </div>
                            </>;
                        })()}
                    </motion.div>
                </div>}
            </AnimatePresence>

            <PageLoad loading={loading} />

        </div>
    )
}

export default Home